import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Catalogue from "@/pages/Catalogue";
import ProductDetail from "@/pages/ProductDetail";
import GovernanceModel from "@/pages/GovernanceModel";
import BookBriefing from "@/pages/BookBriefing";
import ReadinessCheck from "@/pages/ReadinessCheck";
import PricingRules from "@/pages/PricingRules";
import DataHandling from "@/pages/DataHandling";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Focus-mode routes without the standard chrome */}
        <Route path="/readiness-check" element={<ReadinessCheck />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />

        {/* Standard site */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/catalogue" element={<Catalogue />} />
          <Route path="/catalogue/:slug" element={<ProductDetail />} />
          <Route path="/governance-model" element={<GovernanceModel />} />
          <Route path="/book-briefing" element={<BookBriefing />} />
          <Route path="/pricing-rules" element={<PricingRules />} />
          <Route path="/data-handling" element={<DataHandling />} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
